module.exports = __webpack_public_path__ + "static/media/about-banner@mobile-niks.afd850ba.png";